






















































import { apiClient } from "../../services/api-client";
import BaseIconAlert from "../../components/Base/BaseIconAlert.vue";
import { requiresAnonymousMixin } from "../../mixins/requiresAnonymousMixin";
import BasePageMinimal from "@/components/Base/BasePageMinimal.vue";

export default {
  name: "WachtwoordVergeten",
  components: { BasePageMinimal, BaseIconAlert },
  mixins: [requiresAnonymousMixin],
  data() {
    return {
      email: "",
      isValidated: false,
      isSend: false
    };
  },
  methods: {
    submit() {
      apiClient
        .wachtwoordVergeten({
          username: this.email,
          emailSettings: {
            subject: this.$t("WachtwoordVergetenEmail.subject")
          }
        })
        .then(() => {
          this.isSend = true;
        });
    }
  }
};
